/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { convertKeysCase } from './convertCase';

export const mergeFormObjects = (
  input: Record<string, any>,
  apiVersion2: boolean
) => {
  const baseKeys = [
    'dob',
    'email',
    'firstname',
    'gender',
    'lastname',
    'middlename',
    'password',
    'prefix',
    'suffix',
    'taxvat',
  ];

  const newInputs = convertKeysCase(input, 'snakeCase', {
    firstName: 'firstname',
    lastName: 'lastname',
  });

  if (!apiVersion2)
    return {
      ...newInputs,
      ...(newInputs?.gender ? { gender: Number(newInputs?.gender) } : {}),
    };

  const result: Record<string, any> = {};
  const customAttributes: Record<string, any>[] = [];

  Object.keys(newInputs).forEach((key: string) => {
    if (baseKeys.includes(key)) {
      result[key] = key.includes('gender')
        ? Number(newInputs[key])
        : newInputs[key];
    } else {
      customAttributes.push({
        attribute_code: key,
        value: newInputs[key],
      });
    }
  });

  if (customAttributes.length > 0) {
    result.custom_attributes = customAttributes;
  }

  return result;
};
